<template>
  <nav class="header" :class="{ 'header--scrolled': scrolled }">
    <div class="container header__inner">
      <!-- Logo -->
      <a class="header__brand" href="#/" @click.prevent="go('home')">
        <img :src="nav.logoImg" class="header__logo" alt="infimind" />
        <!-- <span
          class="header__name"
          :class="{ 'header__name--dark': scrolled || isAbout }"
          >{{ nav.logoText }}</span
        > -->
      </a>

      <!-- 桌面导航 -->
      <div class="header__nav">
        <template v-for="link in nav.links">
          <!-- 产品介绍：带下拉 -->
          <div
            v-if="link.id === 'products'"
            :key="link.id"
            class="header__dropdown"
            @mouseenter="dropdownOpen = true"
            @mouseleave="dropdownOpen = false"
          >
            <button
              class="header__dropdown-trigger"
              :class="{ 'header__link--dark': scrolled || isAbout }"
              @click="go(link.id)"
            >
              {{ link.label }}
              <svg
                class="header__chevron"
                :class="{ 'is-open': dropdownOpen }"
                xmlns="http://www.w3.org/2000/svg"
                width="16"
                height="16"
                viewBox="0 0 24 24"
                fill="none"
                stroke="currentColor"
                stroke-width="2"
                stroke-linecap="round"
                stroke-linejoin="round"
              >
                <path d="m6 9 6 6 6-6" />
              </svg>
            </button>
            <transition name="dropdown">
              <div v-if="dropdownOpen" class="header__menu">
                <img :src="nav.menuBg" class="header__menu-bg" alt="" />
                <div class="header__menu-grid">
                  <div
                    v-for="group in nav.productMenu"
                    :key="group.title"
                    class="header__menu-group"
                  >
                    <h4 class="header__menu-title">{{ group.title }}</h4>
                    <div class="header__menu-list">
                      <a
                        v-for="item in group.items"
                        :key="item.title"
                        class="header__menu-item"
                        href="#products"
                        @click.prevent="handleToDownload(item)"
                      >
                        <div
                          class="header__menu-icon"
                          :style="{ color: iconColor(item.color) }"
                        >
                          <svg
                            xmlns="http://www.w3.org/2000/svg"
                            width="20"
                            height="20"
                            viewBox="0 0 24 24"
                            fill="none"
                            stroke="currentColor"
                            stroke-width="2"
                            stroke-linecap="round"
                            stroke-linejoin="round"
                            v-html="iconInner(item.icon)"
                          ></svg>
                        </div>
                        <div>
                          <div class="header__menu-item-title">
                            {{ item.title }}
                          </div>
                          <div class="header__menu-item-desc">
                            {{ item.desc }}
                          </div>
                        </div>
                      </a>
                    </div>
                  </div>
                </div>
              </div>
            </transition>
          </div>

          <!-- 普通链接 -->
          <a
            v-else
            :key="link.id"
            class="header__link"
            :class="{ 'header__link--dark': scrolled || isAbout }"
            :href="link.id === 'about' ? '#/about' : '#' + link.id"
            @click.prevent="go(link.id)"
            >{{ link.label }}</a
          >
        </template>
      </div>

      <!-- 右侧操作 -->
      <div class="header__actions">
        <button
          class="header__cta"
          :class="{ 'header__cta--dark': isAbout }"
          @click="go('contact')"
        >
          {{ nav.cta }}
        </button>
      </div>

      <!-- 移动端 -->
      <button
        class="header__burger"
        :class="{ 'header__burger--dark': scrolled || isAbout }"
        @click="menuOpen = !menuOpen"
      >
        <svg
          xmlns="http://www.w3.org/2000/svg"
          width="24"
          height="24"
          viewBox="0 0 24 24"
          fill="none"
          stroke="currentColor"
          stroke-width="2"
          stroke-linecap="round"
          stroke-linejoin="round"
        >
          <line x1="4" x2="20" y1="12" y2="12" />
          <line x1="4" x2="20" y1="6" y2="6" />
          <line x1="4" x2="20" y1="18" y2="18" />
        </svg>
      </button>
    </div>

    <!-- 移动端菜单 -->
    <transition name="fade">
      <div v-if="menuOpen" class="header__mobile">
        <div class="header__mobile-list">
          <a
            v-for="link in nav.links"
            :key="link.id"
            class="header__mobile-link"
            :href="link.id === 'about' ? '#/about' : '#' + link.id"
            @click.prevent="go(link.id)"
            >{{ link.label }}</a
          >
          <button class="header__mobile-cta" @click="go('contact')">
            {{ nav.cta }}
          </button>
        </div>
      </div>
    </transition>
  </nav>
</template>

<script>
import { nav } from "@/assets/data/content";

const ICON_PATHS = {
  image:
    '<rect width="18" height="18" x="3" y="3" rx="2" ry="2"/><circle cx="9" cy="9" r="2"/><path d="m21 15-3.086-3.086a2 2 0 0 0-2.828 0L6 21"/>',
  "wand-sparkles":
    '<path d="m21.64 3.64-1.28-1.28a1.21 1.21 0 0 0-1.72 0L2.36 18.64a1.21 1.21 0 0 0 0 1.72l1.28 1.28a1.2 1.2 0 0 0 1.72 0L21.64 5.36a1.2 1.2 0 0 0 0-1.72"/><path d="m14 7 3 3"/><path d="M5 6v4"/><path d="M19 14v4"/><path d="M10 2v2"/><path d="M7 8H3"/><path d="M21 16h-4"/><path d="M11 3H9"/>',
  "image-plus":
    '<path d="M16 5h6"/><path d="M19 2v6"/><path d="M21 11.5V19a2 2 0 0 1-2 2H5a2 2 0 0 1-2-2V5a2 2 0 0 1 2-2h7.5"/><path d="m21 15-3.086-3.086a2 2 0 0 0-2.828 0L6 21"/><circle cx="9" cy="9" r="2"/>',
  video:
    '<path d="m16 13 5.223 3.482a.5.5 0 0 0 .777-.416V7.87a.5.5 0 0 0-.752-.432L16 10.5"/><rect x="2" y="6" width="14" height="12" rx="2"/>',
  scissors:
    '<circle cx="6" cy="6" r="3"/><path d="M8.12 8.12 12 12"/><path d="M20 4 8.12 15.88"/><circle cx="6" cy="18" r="3"/><path d="M14.8 14.8 20 20"/>',
  factory:
    '<path d="M2 20a2 2 0 0 0 2 2h16a2 2 0 0 0 2-2V8l-7 5V8l-7 5V4a2 2 0 0 0-2-2H4a2 2 0 0 0-2 2Z"/><path d="M17 18h1"/><path d="M12 18h1"/><path d="M7 18h1"/>',
};

const ICON_COLORS = {
  "text-cyan-500": "#06b6d4",
  "text-purple-500": "#a855f7",
  "text-blue-500": "#3b82f6",
  "text-indigo-500": "#6366f1",
  "text-emerald-500": "#10b981",
  "text-slate-600": "#475569",
};

export default {
  name: "TheHeader",
  data() {
    return { nav, scrolled: false, menuOpen: false, dropdownOpen: false };
  },
  computed: {
    isAbout() {
      return this.$route && this.$route.path === "/about";
    },
  },
  mounted() {
    window.addEventListener("scroll", this.onScroll, { passive: true });
    this.onScroll();
  },
  beforeDestroy() {
    window.removeEventListener("scroll", this.onScroll);
  },
  methods: {
    handleToDownload(row) {
      if (row.title == "AI 私域运营智能体") {
        window.open(
          "https://qcnsu9dyqhu0.feishu.cn/wiki/ABRMwsa2Ri74h0krWFUcXihYn1c",
          "_blank"
        );
      } else {
        window.open(
          "https://qcnsu9dyqhu0.feishu.cn/wiki/ABRMwsa2Ri74h0krWFUcXihYn1c",
          "_blank"
        );
      }
    },
    onScroll() {
      this.scrolled = window.scrollY > 40;
    },
    go(id) {
      this.menuOpen = false;
      this.dropdownOpen = false;
      if (id === "about") {
        if (!this.isAbout) this.$router.push("/about");
        return;
      }
      if (this.isAbout) {
        this.$router.push({ path: "/", query: { scroll: id } });
        return;
      }
      const el = document.getElementById(id);
      if (el) el.scrollIntoView({ behavior: "smooth" });
    },
    iconInner(name) {
      return ICON_PATHS[name] || "";
    },
    iconColor(cls) {
      return ICON_COLORS[cls] || "currentColor";
    },
  },
};
</script>

<style scoped>
.dropdown-enter-active,
.dropdown-leave-active {
  transition: opacity 0.15s ease, transform 0.15s ease;
}
.dropdown-enter,
.dropdown-leave-to {
  opacity: 0;
  transform: translateY(-4px);
}
.fade-enter-active,
.fade-leave-active {
  transition: opacity 0.2s ease;
}
.fade-enter,
.fade-leave-to {
  opacity: 0;
}
</style>
